import { NzModalService } from 'ng-zorro-antd/modal';
import { Component,EventEmitter,Input, OnDestroy, OnInit,Output } from '@angular/core';
import { SubscriptionService } from "../../../services/subscription.service";
import { ProfileService } from "../../../services/profile.service";
import { PaginatorState } from "../../../services/crud-table/models/paginator.model";
import { GroupingState } from "../../../services/crud-table/models/grouping.model";
import { NotificationService } from "../../../services/notification.service";
import { Observable } from "rxjs";
import {CURRENCY_ROUND} from "../../../constants";
import {TranslateService} from "@ngx-translate/core";

@Component({
	selector: 'app-subscription-modal',
	templateUrl: './subscription-modal.component.html',
	styleUrls: ['./subscription-modal.component.scss']
})
export class SubscriptionModalComponent implements OnInit, OnDestroy {

	@Input() isManaged: boolean = false;
	@Input() orgId: string = "";
	@Input() availableSubscriptions = [];
	@Output() modalStateChange = new EventEmitter<boolean>();

	acceptedTermsConditions: boolean = false;
	_profileType: string;
	activeSubscription = {};
	defaultSubscriptions = [];
	subscriptions$: Observable<any>;
	defaultCurrencySymbol: string = CURRENCY_ROUND.COMMON;
	currentLanguage: string;
	selectedPlan = {};
	selectedPlanType: boolean = false;

	constructor(
		private modalService: NzModalService,
		private subscriptionService: SubscriptionService,
		private profileService: ProfileService,
		private notificationService: NotificationService,
		private translateService: TranslateService
	) { }

	ngOnInit(): void {
		this.defaultSubscriptions = this.availableSubscriptions.slice(0, 3);
		this.subscriptions$ = this.subscriptionService.subs$;
		this._profileType = this.profileService.profileType;
		this.subscriptionService.activeSubscription$.subscribe((response) => {
			this.activeSubscription = response;
		});
		this.currentLanguage = this.translateService.currentLang;
		this.translateService.onLangChange.subscribe((response) => {
			this.currentLanguage = response.lang;
		});
	}

	changePlanType() {
		this.selectedPlanType = !this.selectedPlanType;
		this.selectedPlan = {};
		this.defaultSubscriptions.map(sub => { delete sub['isSelected']; });
	}

	planSelected(planData) {
		if(this.selectedPlanType && planData['priceYearly'] === 0) {
			return;
		} else if(!this.selectedPlanType && planData['priceMonthly'] === 0) {
			return;
		}

		if(planData.id !== this.selectedPlan) {
			delete this.selectedPlan['isSelected'];
		}
		this.selectedPlan = planData;
		this.selectedPlan['isSelected'] = true;
	}

	/**
	 * Get the plan Id and subscribe with it for user
	 */
	subscribe(): void {
		const subscriptionPayload = {
			defaultSubscriptionId: this.selectedPlan['id'],
			paymentType: this.selectedPlanType === false ? 1 : 2,
		};

		this.subscriptionService.createSubscription(subscriptionPayload).subscribe((response) => {
			if(response.status === 201){
				this.notificationService.successNotification("subscription_created");
				this.subscriptionService.tableState = {
					filter: {
						status: 1
					},
					paginator: new PaginatorState(),
					sorting: {
						column: "createdAt",
						direction: "desc",
					},
					searchTerm: "",
					grouping: new GroupingState(),
				};
				this.subscriptionService.getActiveSubscriptions();
				this.modalService.closeAll();
			}
		}, (errorResponse) => {
			const { error } = errorResponse;
			if (error.status === 409) {
				// subscription is already active, send success toast
				this.notificationService.successNotification("subscription_already_active");
				this.subscriptionService.tableState = {
					filter: {
						status: 1
					},
					paginator: new PaginatorState(),
					sorting: {
						column: "createdAt",
						direction: "desc",
					},
					searchTerm: "",
					grouping: new GroupingState(),
				};
				this.subscriptionService.getActiveSubscriptions();
				this.modalService.closeAll();
			}
		});
	}

	getPrice(price) {
		return parseFloat(price);
	}

	ngOnDestroy(): void {
		this.defaultSubscriptions.map(sub => { delete sub['isSelected']; });
	}
}
